// Analytics tracking utility for GA4 (G-G4YVCCGB93)

export function trackEvent(eventName, params = {}) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
}

// --- Form funnel ---
export function trackFormStart() { trackEvent('form_start', { form_name: 'cincin_contact' }); }
export function trackFormStepEventType(value) { trackEvent('form_step_event_type', { event_type: value }); }
export function trackFormStepBudget(value) { trackEvent('form_step_budget', { budget_range: value }); }
export function trackFormStepLocation() { trackEvent('form_step_location', { location_entered: true }); }
export function trackFormStepContactStarted() { trackEvent('form_step_contact_started', { started: true }); }
export function trackFormAbandon(lastStep, timeSpent) { trackEvent('form_abandon', { last_step: lastStep, time_spent: timeSpent }); }
export function trackFormSubmit() { trackEvent('form_submit', { event_category: 'lead', event_label: 'contact_form' }); }

// --- WhatsApp ---
export function trackWhatsAppClick(source = 'whatsapp_button', lastStep = '') {
  trackEvent('whatsapp_click', { event_category: 'engagement', source, last_step: lastStep });
}

// --- CTA ---
export function trackCtaClick(location = 'primary_cta') {
  trackEvent('cta_click', { location });
}

// --- Service expand ---
export function trackServiceExpand(section) { trackEvent('service_expand', { section }); }

// --- Portfolio ---
export function trackPortfolioFilter(category) { trackEvent('portfolio_filter_click', { category }); }
export function trackPortfolioItemClick(category) { trackEvent('portfolio_item_click', { category }); }

// --- Engagement ---
export function trackContactPageView() { trackEvent('contact_page_view'); }
export function trackConversion(type) { trackEvent(type); }

// --- Scroll depth + engaged time (init once) ---
let scrollTracked50 = false;
let scrollTracked75 = false;
let engagedTracked = false;

export function initBehaviorTracking() {
  // Scroll depth
  const onScroll = () => {
    const scrollPct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
    if (!scrollTracked50 && scrollPct >= 0.5) { scrollTracked50 = true; trackEvent('scroll_50'); }
    if (!scrollTracked75 && scrollPct >= 0.75) { scrollTracked75 = true; trackEvent('scroll_75'); }
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  // Engaged 30s
  setTimeout(() => {
    if (!engagedTracked) { engagedTracked = true; trackEvent('engaged_30s'); }
  }, 30000);
}
